import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RocketLaunchIcon from '@mui/icons-material/EmojiEvents';

import {
    markFirstAccessSeen,
    openChecklist,
} from '../../../redux/actions/onboarding';
import { isUserOnTrial } from '../configs/onboarding.config';

class WelcomeModal extends Component {
    shouldRender = () => {
        const { userSession, onboarding } = this.props;

        // Gate 1: usuario logado
        if (!userSession?.user) return false;

        // Gate 2: SO trials veem o welcome modal
        if (!isUserOnTrial(userSession.user)) return false;

        // Gate 3: ainda nao viu o welcome (firstaccess === false na convencao do projeto)
        const userFirstAccess = userSession.user?.firstaccess;
        const reduxFirstAccess = onboarding?.firstAccess;
        if (reduxFirstAccess !== null && reduxFirstAccess !== undefined) {
            return reduxFirstAccess === false;
        }
        return userFirstAccess === false;
    };

    handleSkip = () => {
        this.props.markFirstAccessSeen();
    };

    handleStartTour = () => {
        this.props.markFirstAccessSeen();
        this.props.openChecklist();
    };

    render() {
        if (!this.shouldRender()) return null;

        const { userSession, intl } = this.props;
        const userName = (userSession?.user?.name || '').split(' ')[0] || '';

        const title = userName
            ? intl.formatMessage({ id: 'onboarding.welcome.title' }, { name: userName })
            : intl.formatMessage({ id: 'onboarding.welcome.title.fallback' });

        return (
            <Dialog
                open
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { borderRadius: '16px' } }}
            >
                <Box sx={{ position: 'relative', p: 4, textAlign: 'center' }}>
                    <IconButton
                        aria-label={intl.formatMessage({ id: 'onboarding.tour.close' })}
                        onClick={this.handleSkip}
                        sx={{ position: 'absolute', right: 12, top: 12, color: '#999' }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Box
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: '50%',
                            backgroundColor: '#e8f5e9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                        }}
                    >
                        <RocketLaunchIcon sx={{ color: '#8BC34A', fontSize: 40 }} />
                    </Box>

                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 700, color: '#212121', mb: 1 }}
                    >
                        {title}
                    </Typography>

                    <Typography variant="body1" sx={{ color: '#555', mb: 2 }}>
                        {intl.formatMessage({ id: 'onboarding.welcome.description' })}
                    </Typography>

                    <Box
                        sx={{
                            backgroundColor: '#f5f5f5',
                            borderRadius: '12px',
                            p: 2,
                            mb: 1,
                            color: '#888',
                            fontSize: 14,
                            fontStyle: 'italic',
                        }}
                    >
                        {intl.formatMessage({ id: 'onboarding.welcome.video.placeholder' })}
                    </Box>

                    <DialogContent sx={{ px: 0, py: 0 }}>
                        <Typography variant="body2" sx={{ color: '#777', mb: 2 }}>
                            {intl.formatMessage({ id: 'onboarding.welcome.subtext' })}
                        </Typography>
                    </DialogContent>

                    <DialogActions
                        sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 1, p: 0, mt: 1 }}
                    >
                        <Button
                            variant="outlined"
                            onClick={this.handleSkip}
                            sx={{
                                borderColor: '#bdbdbd',
                                color: '#555',
                                textTransform: 'none',
                                fontWeight: 500,
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            {intl.formatMessage({ id: 'onboarding.welcome.btn.skip' })}
                        </Button>

                        <Button
                            variant="contained"
                            onClick={this.handleStartTour}
                            sx={{
                                backgroundColor: '#8BC34A',
                                '&:hover': { backgroundColor: '#7cb342' },
                                textTransform: 'none',
                                fontWeight: 600,
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            {intl.formatMessage({ id: 'onboarding.welcome.btn.start' })}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    userSession: state.userSession,
    onboarding: state.onboarding,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ markFirstAccessSeen, openChecklist }, dispatch);

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(WelcomeModal)));
